import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default (state = initialState.ads, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_ADS_SNAPSHOT:
      return {
        ...state,
        data: action.ads,
        endBefore: action.endBefore,
        startAfter: action.startAfter
      };
    case ActionTypes.RECEIVE_ADS_TOTAL_COUNT_SNAPSHOT:
      return { ...state, totalCount: action.totalCount };
    case ActionTypes.SET_ADS_SEARCH_CRITERIA:
      return { ...state, ...action.searchCriteria };
    case ActionTypes.SET_ADS_COLUMN_VISIBILITY: {
      return {
        ...state,
        columns: state.columns.map(column => {
          if (column.id === action.column.id) {
            return { ...column, visible: action.column.visible ? false : true };
          }
          return column;
        })
      };
    }
    default:
      return state;
  }
};
